import React, { Component } from 'react'
import { app } from "@microsoft/teams-js";

import './Login.scss'

export default class Config extends Component {

    componentDidMount() {
        app.initialize();
        app.settings.setValidityState(true);
        app.settings.registerOnSaveHandler(function (saveEvent) {

            app.settings.setSettings({
                entityId: "1",
                contentUrl: "https://dev-teams.asc-recording.app/",
                suggestedDisplayName: "Recordings"
            });
            saveEvent.notifySuccess();
        });
    }

    render() {
        return (
            <div className="login-body">
            </div>
        );
    }
}
